import React from 'react';

import currencyFormatter from 'currency-formatter';
import { Link as NavLink } from '~/lib/react-router-dom';

import { Alert, Box, Link, Stack, Typography } from '@mui/material';

import type { CreditReversalOrder } from '~/services/OrdersService';
import { formatDateWeekDayShortMonth } from '~/services/TimeService';

interface Props {
  order: CreditReversalOrder;
}

export default function OrderSummaryCard({ order }: Props) {
  const maxReversalFormatted = currencyFormatter.format(order.maxReversal, {
    code: order.currency,
    precision: 2,
  });

  return (
    <Alert severity="info" icon={false}>
      <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
        <Box>
          <Stack direction="row" spacing={4}>
            <InfoLine
              label="Selected Order"
              value={
                <Link component={NavLink} to={`/purchases/${order.orderId}`} underline="hover">
                  {order.orderId}
                </Link>
              }
            />

            <InfoLine label="Package Details" value={order.packageDetails} />
          </Stack>

          <Stack direction="row" spacing={4}>
            <InfoLine label="Transaction Date" value={formatDateWeekDayShortMonth(order.transactionDate)} />
            <InfoLine label="Maximum Reversal" value={maxReversalFormatted + ' ' + order.currency} />
            <InfoLine label="Check-In" value={order.checkIn ? formatDateWeekDayShortMonth(order.checkIn) : null} />
            <InfoLine label="Check-Out" value={order.checkOut ? formatDateWeekDayShortMonth(order.checkOut) : null} />
          </Stack>
        </Box>
      </Stack>
    </Alert>
  );
}

function InfoLine({ label, value }: { label: string; value: string | React.ReactNode | null }) {
  return (
    <Typography variant="body2" fontWeight="medium" color="text.secondary">
      {label}
      {': '}
      <Typography variant="body2" fontWeight="bold" component="span">
        {value ?? '-'}
      </Typography>
    </Typography>
  );
}
